/**
 * Personel giriş doğrulaması — client-side.
 * Şifre karşılaştırması artık burada YAPILMAZ; sadece sunucuya (Admin SDK) gönderilir.
 */
import { apiUrl } from './apiBase';
import { auth } from '../firebase';

export async function verifyPersonelLoginApi({ subeKey, personelId, password }) {
  const headers = { 'Content-Type': 'application/json' };
  const sharedSecret = String(process.env.REACT_APP_CAMPAIGN_AI_SHARED_SECRET || '').trim();
  if (sharedSecret) headers['x-ukba-internal-key'] = sharedSecret;
  try {
    const token = await auth.currentUser?.getIdToken?.();
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch (_) {
    /* ignore */
  }

  let res;
  try {
    res = await fetch(apiUrl('/api/personel/verify-login'), {
      method: 'POST',
      headers,
      body: JSON.stringify({ subeKey, personelId, password })
    });
  } catch (_networkErr) {
    return {
      ok: false,
      code: 'network-error',
      message: 'Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.'
    };
  }

  let data = {};
  try {
    data = await res.json();
  } catch (_) {
    data = {};
  }

  if (!data || typeof data.ok !== 'boolean') {
    return { ok: false, code: 'server-error', message: 'Sunucu hatası. Lütfen tekrar deneyin.' };
  }
  return data;
}
